import { useEffect, useState } from 'react';
import {
  MessageBar,
  MessageBarType,
  PrimaryButton,
  Stack,
  Text,
  TextField,
} from '@fluentui/react';
import {
  getGlobalCancellationPolicy,
  updateGlobalCancellationPolicy,
} from '../../services/settingsService';

const CancellationPolicy = () => {
  const [hours, setHours] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string>();
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    getGlobalCancellationPolicy(controller)
      .then((policy) => {
        setHours(policy.value);
        setLoaded(true);
      })
      .catch((e: Error) => {
        if (!controller.signal.aborted) setError(e.message);
      });
    return () => controller.abort();
  }, []);
  const valid = /^\d+(?:\.\d{1,3})?$/.test(hours) && Number(hours) <= 87600;
  const save = async () => {
    setSaving(true);
    setError(undefined);
    setSaved(false);
    try {
      await updateGlobalCancellationPolicy(
        new AbortController(),
        Number(hours)
      );
      setSaved(true);
    } catch (e) {
      setError(
        e instanceof Error ? e.message : 'Unable to save cancellation policy.'
      );
    } finally {
      setSaving(false);
    }
  };
  return (
    <Stack tokens={{ childrenGap: 12 }} styles={{ root: { maxWidth: 560 } }}>
      <Text>
        This policy applies to all tenants. Changes apply to future cancellation
        decisions; recorded decisions retain the threshold used.
      </Text>
      {error && (
        <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>
      )}
      {saved && (
        <MessageBar messageBarType={MessageBarType.success}>
          Cancellation policy saved.
        </MessageBar>
      )}
      <TextField
        label="Cancellation notice hours"
        value={hours}
        disabled={!loaded || saving}
        onChange={(_, value) => {
          setHours(value ?? '');
          setSaved(false);
        }}
        description="Enter 0–87,600 hours, with up to three decimal places. Zero is allowed."
        errorMessage={
          loaded && !valid ? 'Enter a valid number of hours.' : undefined
        }
      />
      <Stack horizontal>
        <PrimaryButton
          text={saving ? 'Saving…' : 'Save'}
          disabled={!loaded || saving || !valid}
          onClick={save}
        />
      </Stack>
    </Stack>
  );
};
export default CancellationPolicy;
